module.exports = __webpack_public_path__ + "static/userIcon.f9fcc796.png";